import React, { Component } from "react";

class ModalImage extends Component {
  render() {
    return (
      <div
        className="modal fade modal-img"
        id={this.props.id}
        tabIndex="-1"
        // aria-labelledby="roadmapModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body p-2">
              <div className="close">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <img
                alt="Roadmap Q4"
                src={this.props.src}
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            {/* <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Ok
                </button>
              </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default ModalImage;
